import http, { BASE_URL_3 } from '../../http';
import { getRBPStringId } from '../../../page/main/main-page-states';

/**
 * 餐厅员工 CRUD — 与终端 RBP `staff-manager` 中 `employee` 接口语义一致，
 * 路径按云 Shell 惯例挂载当前餐厅 `string_id`（与 `employee_class/${sid}` 一致）。
 */
const employeeApi = {
    async get_employee_information(rbpStringId?: string): Promise<unknown> {
        const sid = (rbpStringId && rbpStringId.trim()) || getRBPStringId();
        return await http.get(`${BASE_URL_3}/employee/${sid}`);
    },

    async post_employee_information(params: Record<string, unknown>, rbpStringId?: string): Promise<unknown> {
        const sid = (rbpStringId && rbpStringId.trim()) || getRBPStringId();
        return await http.post(`${BASE_URL_3}/employee/${sid}`, params);
    },

    async patch_employee_information(employeeId: number, data: Record<string, unknown>, rbpStringId?: string): Promise<unknown> {
        const sid = (rbpStringId && rbpStringId.trim()) || getRBPStringId();
        return await http.patch(`${BASE_URL_3}/employee/${employeeId}/${sid}`, data);
    },

    async delete_employee_information(employeeId: number, rbpStringId?: string): Promise<unknown> {
        const sid = (rbpStringId && rbpStringId.trim()) || getRBPStringId();
        return await http.delete(`${BASE_URL_3}/employee/${employeeId}/${sid}`);
    },
};

export default employeeApi;
